import { Button } from 'src/core/ui';
import { MainNavTopBarEmpty } from 'src/navigations/MainNav/MainNavTopBar';

import * as styles from './TicketUtilsLanding.css';

const TicketUtilsMarkIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="39" cy="39" r="39" fill="#4CB1FF" />
    <path
      d="M34.8449 20.8743V15C33.5395 15.8703 30.9287 17.2845 30.9287 18.9162V24.7906C30.9287 27.1403 32.8868 28.7068 35.4976 28.7068V33.2757C37.4558 33.2757 39.4139 33.9284 40.0666 35.8865H42.351V28.7068C44.6355 28.7068 46.5936 27.075 46.5936 24.7906V18.9162C46.5936 17.3497 43.7652 15.6527 42.351 15V20.8743C42.1335 21.527 41.0456 22.8325 38.4348 22.8325C35.824 22.8325 34.9537 21.527 34.8449 20.8743Z"
      fill="white"
    />
    <path
      d="M42.351 60.6893V41.1082H40.0666C39.0875 43.3926 36.803 43.719 35.4976 43.3926V60.0366C35.4976 60.6893 36.1503 62.6474 39.0875 62.6474C41.4373 62.6474 42.0247 61.443 42.351 60.6893Z"
      fill="white"
    />
    <path
      d="M27.665 35.2338C29.0031 35.2338 30.1526 36.0394 30.6562 37.1918H33.1582C33.6618 36.0392 34.8121 35.2338 36.1504 35.2338C37.4885 35.2339 38.638 36.0393 39.1416 37.1918H52.4678V35.8861H55.0781V37.1918H57.0361C57.7571 37.1918 58.3418 37.7765 58.3418 38.4974C58.3417 39.2183 57.7571 39.8031 57.0361 39.8031H55.0781V41.1078H52.4678V39.8031H39.1416C38.6379 40.9553 37.4883 41.761 36.1504 41.7611C34.8123 41.7611 33.6619 40.9555 33.1582 39.8031H30.6562C30.1525 40.9554 29.003 41.7611 27.665 41.7611H15.2637C13.4613 41.7611 12.0001 40.2998 12 38.4974C12 36.695 13.4613 35.2338 15.2637 35.2338H27.665Z"
      fill="black"
    />
  </svg>
);

const ReachProCircleIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="39" cy="39" r="38.5" fill="white" stroke="#C7C9CC" />
    <g transform="translate(23, 20) scale(0.025)">
      <path
        d="M 448.035156 0 C 432.667969 0.128906 418.125 6.988281 408.257812 18.761719 L 10.703125 497.15625 C 3.96875 505.203125 0.269531 515.367188 0.269531 525.863281 L 0.269531 1203.859375 C 0.269531 1243.554688 30.714844 1276.132812 69.53125 1279.507812 L 365.875 1279.507812 C 391.503906 1276.78125 411.46875 1255.097656 411.46875 1228.75 L 411.46875 210.667969 C 411.46875 210.667969 413.105469 155.429688 454.28125 150.613281 C 459.398438 150.011719 464.097656 149.722656 468.433594 149.722656 C 499.023438 149.722656 511.9375 163.976562 529.429688 183.917969 C 537.929688 193.59375 688.417969 366.316406 858.613281 561.660156 L 637.738281 810.851562 C 629.730469 819.878906 629.433594 833.375 637.019531 842.75 L 964.792969 1268.492188 C 969.867188 1274.773438 977.226562 1278.710938 985.171875 1279.5 L 1285.355469 1279.5 C 1306.796875 1278.261719 1342.171875 1268.484375 1365.042969 1222.351562 C 1370.152344 1212.054688 1372.691406 1201.960938 1373.519531 1192.421875 L 1373.519531 1177.929688 C 1371.402344 1152.789062 1358.96875 1133.585938 1355.289062 1128.398438 C 1354.707031 1127.578125 1354.128906 1126.847656 1353.46875 1126.089844 C 1337.90625 1108.214844 1097.558594 812.710938 880.285156 562.53125 L 1108.15625 305.441406 C 1123.359375 288.289062 1122.378906 262.199219 1105.925781 246.234375 L 867.738281 15.195312 C 857.691406 5.449219 844.238281 0 830.253906 0 C 830.105469 0 829.964844 0 829.8125 0 Z"
        fill="#1A1A1A"
      />
    </g>
  </svg>
);

export const TicketUtilsLanding = () => {
  const handleContactClick = () => {
    window.location.href = 'mailto:welcome@reachpro.com';
  };

  return (
    <>
      <MainNavTopBarEmpty />
      <div className={styles.pageWrapper}>
        <div className={styles.blurredBackground} />
        <div className={styles.overlay} />
        <div className={styles.container}>
          <div className={styles.card}>
            <div className={styles.iconsContainer}>
              <TicketUtilsMarkIcon />
              <div className={styles.reachProIconWrapper}>
                <ReachProCircleIcon />
              </div>
            </div>

            <h1 className={styles.title}>Ticket Utils is now ReachPro&trade;</h1>

            <p className={styles.description}>
              We have already migrated all of your business' data into a new
              ReachPro&trade; account.
              <br />
              <br />
              Contact our Accounts Team to obtain your account credentials.
            </p>

            <Button className={styles.ctaButton} onClick={handleContactClick}>
              Contact our Accounts Team
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
